export default __webpack_public_path__ + "static/test_1_3_ru-7615925cb004a444742a455d224f16e1.png";